import styled from 'styled-components';

import { xdlPalettePetrol09, xdlPaletteWhite } from '@xing-com/tokens';

export const Container = styled.div`
  background-color: ${xdlPalettePetrol09};
  height: 0;
  max-width: 100%;
  padding-top: 56.25%; /* 9/16 - video ratio */
  position: relative;
  width: 100%;
`;

export const InnerContainer = styled.div`
  align-items: center;
  color: ${xdlPaletteWhite};
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;

  p {
    color: ${xdlPaletteWhite} !important;
  }
`;
